import { bus } from '@/app';

export default {
    methods: {
        getExternalItem(item) {
            let externalActivities = this.$store.getters['dayConfigurator/externalActivities'];
            if (externalActivities.length > 0) {
                let externalItem = externalActivities.filter(a => a.id === parseInt(item.data.external_id));
                if (externalItem.length >= 1) return externalItem[0];
            }
            return null;
        },

        makeActivityObject(type, start, duration, payload) {
            let activity_object = null;
            if (type === 'listed' || type === 'activity' || type === 'speaker' || type === 'staticItem' || type === 'location') {
                activity_object = {
                    type: 'listed',
                    start: start,
                    duration: duration,
                    data: {
                        external_id: payload.data.id,
                        external_type: payload.type,
                        payload: payload.data
                    }
                }
            } else if (type === 'own') {
                activity_object = {
                    type: type,
                    start: start,
                    duration: duration,
                    data: {
                        name: payload.data.name,
                        has_requests: payload.data.has_requests,
                        requests: payload.data.requests,
                        remarks: payload.data.remarks,
                    }
                }
            } else if (type === 'break') {
                activity_object = {
                    type: type,
                    start: start,
                    duration: duration,
                    data: {
                        remarks: payload.data.remarks,
                        needs_catering: payload.data.needs_catering,
                        catering_remarks: payload.data.catering,
                    }
                }
            }
            return activity_object;
        },

        activityStartEndString(activity) {
            if (activity != null) {
                let hours = (activity.duration / 60);
                let rhours = Math.floor(hours);
                let minutes = (hours - rhours) * 60;
                let rminutes = Math.round(minutes);

                let startArray = activity.start.split(':');
                let startHours = parseInt(startArray[0]);
                let startMinutes = parseInt(startArray[1]);

                let endHours = startHours + rhours;
                let endMinutes = startMinutes + rminutes;

                if (endMinutes >= 60) {
                    endHours++;
                    endMinutes = endMinutes - 60;
                }

                let hourString = endHours < 10 ? `0${endHours.toString()}` : endHours.toString();
                let minutesString = endMinutes < 10 ? `0${endMinutes.toString()}` : endMinutes.toString();

                let endString = `${hourString}:${minutesString}`;

                return `${activity.start} - ${endString}`
            }
            return '';
        },

        activityDurationString(totalminutes) {
            let hours = (totalminutes / 60);
            let rhours = Math.floor(hours);
            let minutes = (hours - rhours) * 60;
            let rminutes = Math.round(minutes);

            let string = '';

            if (rhours > 0) {
                string = `${rhours} uur`;

                if (rminutes > 0) {
                    string = `${string} ${rminutes} min`;
                }
            } else {
                if (rminutes > 0) {
                    string = `${rminutes} min`;
                }
            }

            return string;
        },

        prefillLocationField(placeId) {
            return axios.get(route('get-place', placeId))
                .then(response => {
                    bus.$emit('addressUpdate', response.data.result.name);
                    return response.data.result.name;
                })
        },
    },

    computed: {
        schedule() {
            return this.$store.getters['dayConfigurator/schedule'];
        },

        translations() {
            return this.$store.getters['dayConfigurator/translations'];
        },

        externalActivitiesLoaded() {
            return this.$store.getters['dayConfigurator/externalActivitiesLoaded'];
        },

        isReadOnly() {
            return this.$route.name === 'configurator-detail-public';
        },

        canEdit() {
            return !this.isReadOnly;
        },

        formattedAttendees() {
            if (this.schedule.attendee_object != null) {
                switch (this.schedule.attendee_object.type) {
                    case "exact":
                        return `${this.schedule.attendee_object.data.amount} personen`;
                        break;
                    case "estimate":
                        return `${this.schedule.attendee_object.data.min} - ${this.schedule.attendee_object.data.max}${this.schedule.attendee_object.data.max == 300 ? '+' : ''} personen`;
                        break;
                }
            }
        },

        formattedDate() {
            if (this.schedule.date_object != null) {
                const months = {
                    '01': 'januari',
                    '02': 'februari',
                    '03': 'maart',
                    '04': 'april',
                    '05': 'mei',
                    '06': 'juni',
                    '07': 'juli',
                    '08': 'augustus',
                    '09': 'september',
                    '10': 'oktober',
                    '11': 'november',
                    '12': 'december',
                }
                switch (this.schedule.date_object.type) {
                    case "single":
                        let dateArray = this.schedule.date_object.data.date.split('-');
                        return `${dateArray[2]} ${months[dateArray[1]]} ${dateArray[0]}`;
                        break;
                    case "multiple":
                        return this.translations.practical_details.multiple_dates;
                        break;
                    case "period":
                        let startDateArray = this.schedule.date_object.data.start.split('-');
                        let endDateArray = this.schedule.date_object.data.end.split('-');

                        return `${startDateArray[2]} ${months[startDateArray[1]]} ${startDateArray[0]} - ${endDateArray[2]} ${months[endDateArray[1]]} ${endDateArray[0]}`;
                        break;
                    case "unknown":
                        return this.translations.practical_details.unknown_date;
                        break;
                }
            }
            return ''
        },
    }
}